var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import colors from "../../designSystem/colors";
import theme from "../../designSystem/theme";
var EndingBorder = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 24px;\n  border-radius: ", ";\n  background: ", ";\n  z-index: 1;\n"], ["\n  height: 24px;\n  border-radius: ", ";\n  background: ", ";\n  z-index: 1;\n"])), theme.border.radius, colors.background.two);
var ExtraContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  background: ", ";\n  border-radius: ", ";\n  margin-top: -16px;\n  padding: 24px 16px 8px 16px;\n"], ["\n  display: flex;\n  background: ", ";\n  border-radius: ", ";\n  margin-top: -16px;\n  padding: 24px 16px 8px 16px;\n"])), function (props) {
    return props.backgroundColor ? props.backgroundColor : colors.background.three;
}, theme.border.radius);
var EarnModalContentExtra = function (props) { return (_jsxs(_Fragment, { children: [_jsx(EndingBorder, { config: props.config }, void 0), _jsx(ExtraContainer, __assign({}, props), void 0)] }, void 0)); };
export default EarnModalContentExtra;
var templateObject_1, templateObject_2;
//# sourceMappingURL=EarnModalContentExtra.js.map